export const getRequestUrls = resourceId => ({
    requestUrl: `/requests/team-resource-requests?flow=RES_REQUEST_FLOW_SINGLE&resourceId=${resourceId}`,
    vacationUrl: `/requests/vacation-requests?flow=VACATION_FLOW_SINGLE&resourceId=${resourceId}`,
});
